import { Button, Container, Content, Form, Heading, Level, Notification } from 'react-bulma-components';
import React, { Fragment, useState } from 'react';
import { gql, useMutation, useQuery } from '@apollo/client';

import { Loader } from '../components';
import { PageTitle } from '../components';
import _ from 'lodash';
import { useSnackbar } from 'react-simple-snackbar';

const { Control, Field, Input } = Form;

export const DELETE_SNIPPET = gql`
  mutation DeleteSnippet($id: String!) {
    deleteSnippet(id: $id){
      success
      message
      snippet {
        id
      }
    }
  }
`;
export const UPDATE_SNIPPET = gql`
  mutation UpdateSnippet($id: String!, $text: String) {
    updateSnippet(id: $id, text: $text){
      success
      message
      snippet {
        id
        text
      }
    }
  }
`;

const Snippet = ({ id, text }) => {
  const [openSnackbar] = useSnackbar();
  const [deleteSnippet, { loading: mutationDeleteLoading, error: mutationDeleteError }] = useMutation(DELETE_SNIPPET)
  const [updateSnippet, { loading: mutationUpdateLoading, error: mutationUpdateError }] = useMutation(UPDATE_SNIPPET)
  const [snippet, setSnippet] = useState(text);
  const [dirty, setDirty] = useState(false);
  const handleChange = (event) => {
    setDirty(true);
    setSnippet(event.target.value);
  }
  const onDelete = () => {
    deleteSnippet({
      variables: {
        id: id
      },
      update: (cache, { data: { deleteSnippet } }) => {
        openSnackbar(deleteSnippet.message, 2000);
        if (!deleteSnippet.success) {
          return;
        }
        if (deleteSnippet.success) {
          cache.evict({
            id: cache.identify(deleteSnippet.snippet)
          });
          cache.gc();
          //refetch();
        }
      }
    });
  }
  const onSave = () => {
    updateSnippet({
      variables: {
        id: id,
        text: snippet
      },
      update: (cache, { data: { updateSnippet } }) => {
        openSnackbar(updateSnippet.message, 2000);
      }
    });
  }
  return (
    <Field kind='addons'>
      <Control fullwidth>
        <Input value={snippet} onChange={handleChange} />
      </Control>
      <Control>
        <Button color="success" type="button" disabled={false} onClick={onSave}>Save</Button>
      </Control>
      <Control>
        <Button color="danger" type="button" disabled={false} onClick={onDelete}>Delete</Button>
      </Control>
    </Field>
  )
}


export const GET_SNIPPETS = gql`
  query GetSnippets {
    snippets{
      id
      text
    }
  }
`;
export const ADD_SNIPPET = gql`
  mutation AddSnippet($text: String!) {
    addSnippet(text: $text){
      success
      message
      snippet {
        id
        text
      }
    }
  }
`;

export default function Snippets() {
  const [openSnackbar] = useSnackbar();
  const [newSnippetText, setNewSnippetText] = useState("");
  const { data, loading, error, refetch } = useQuery(GET_SNIPPETS);
  const [addSnippet, { loading: mutationLoading, error: mutationError }] = useMutation(ADD_SNIPPET)
  /*   ,
      {
        onError(error) {
          openSnackbar(error.message, 2000);
        },
        onCompleted({ addSong }) {
          openSnackbar(addSong.message, 2000);
          if(addSnippet.success)
          {
            navigate(`/${type}-edit/${addSong.songRevision.slug}`);
          }
        }
      }); */
  const onAddSnippet = () => {
    addSnippet({
      variables: {
        text: newSnippetText
      },
      update: (cache, { data: { addSnippet } }) => {
        openSnackbar(addSnippet.message, 2000);
        if (!addSnippet.success) {
          return;
        }
        if (addSnippet.snippet) {
          setNewSnippetText("");
          refetch();
        }
      }
    });
  }

  if (loading) return <Loader />;
  return (
    <Fragment>
      <PageTitle name="Snippets" description="Custom string templates ..." />
      <Notification>
        <Container>
          <Content>
            {[...data.snippets].sort((a, b) => a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1).map(snippet => {
              return (
                <Snippet key={snippet.id} id={snippet.id} text={snippet.text} />
              )
            })}
            <Field kind='addons'>
              <Control fullwidth>
                <Input value={newSnippetText} onChange={(e) => setNewSnippetText(e.target.value)} />
              </Control>
              <Control>
                <Button color="primary" type="button" disabled={false} onClick={onAddSnippet}>Add</Button>
              </Control>
            </Field>
          </Content>
        </Container>
      </Notification>
    </Fragment>
  );
}
